var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } } return target; }
import * as React from "react";
function SvgCyberAttacks(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 29,
    height: 29,
    viewBox: "0 0 29 29",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 14.5,
    cy: 14.5,
    r: 14.5,
    fill: "#E77D66"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#324A5E",
    d: "M26.442 21.053H3.558a.241.241 0 0 0-.213.357l.362.677c.285.535.838.862 1.443.862h19.7a1.64 1.64 0 0 0 1.443-.862l.362-.677a.243.243 0 0 0-.213-.357"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#2B3B4E",
    d: "M24.784 21.053H5.37a.153.153 0 0 1-.154-.154V7.396c0-.083.065-.154.154-.154h19.414c.083 0 .155.065.155.154v13.503c-.006.083-.072.154-.155.154"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FFF",
    d: "M6.13 19.836h17.894V8.72H6.13z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#324A5E",
    d: "M15.077 7.628a.339.339 0 1 1 0 .677.339.339 0 0 1 0-.677"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#ACB3BA",
    d: "M17.566 21.553h-5.132l-.434-.5h6z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#1EC4B4",
    d: "M6 8h18v12H6z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FFF",
    d: "M16.87 13.077V11.99c0-.83-.674-1.506-1.505-1.506v.261l-.222.53a.736.736 0 0 1 .222-.038c.415 0 .752.338.752.753v1.086h-.752v.328l.304.298-.801.85.426.932-.29.45.998.41-.72.565.075.723h2.286v-4.556h-.772z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FFF",
    d: "M14.244 16.163l.29-.45-.427-.932.802-.85-.304-.298v-.328h-.753v-1.086c0-.337.225-.62.53-.716l.223-.528v-.261h-.001c-.83 0-1.505.674-1.505 1.505v1.086h-.772v4.556h2.27l-.074-.723.718-.565-.997-.41z"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCyberAttacks);
export default __webpack_public_path__ + "static/media/cyber-attacks.1704344f1baa45173130712c8ed0c723.svg";
export { ForwardRef as ReactComponent };